<script>
  import Button from '@components/buttons/button.svelte'
  let { ...allProps } = $props()
</script>

<Button variant="naked" {...allProps} />